import { Toast } from '@delmonicos/shared-design-system-react/src/components/toast/toast';
import {
  ColorModeEnum,
  ThemeNameEnum,
} from '@delmonicos/shared-design-system-react/src/contexts/theme.model';
import ThemeProvider from '@delmonicos/shared-design-system-react/src/contexts/theme.provider';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import { MAIN_CONTENT_ID } from '@app/config/app.config';
import { PermissionsProvider } from '@app/core/authentication/permissions.provider';
import { LanguageInitializer } from '@app/core/locale/language-initializer';

import { store } from 'src/core/store';
import { Router } from 'src/router/router';

export function App(): React.JSX.Element {
  return (
    <ThemeProvider
      theme={ThemeNameEnum.CPMS_BO}
      colorMode={ColorModeEnum.LIGHT}>
      <div id={MAIN_CONTENT_ID}>
        <Provider store={store}>
          <LanguageInitializer>
            <PermissionsProvider>
              <BrowserRouter>
                <Router />
              </BrowserRouter>
            </PermissionsProvider>
            <Toast closeOnClick autoClose={7000} hideProgressBar />
          </LanguageInitializer>
        </Provider>
      </div>
    </ThemeProvider>
  );
}
